/**
 * Product Card – Alternating Sold / Review rows
 * Shows one prd-row at a time, switching every 3 s with a CSS fade.
 *
 * Works on:
 *  • Initial page load
 *  • Dynamically injected cards (infinite scroll, AJAX collection filters)
 */
(function () {
  'use strict';

  var INTERVAL_MS = 3000;

  function initPrdStatus() {
    var containers = document.querySelectorAll('.prd-status');
    for (var i = 0; i < containers.length; i++) {
      var el = containers[i];
      if (el.dataset.initialized) continue;
      el.dataset.initialized = 'true';

      var rows = el.querySelectorAll('.prd-row');
      if (rows.length < 2) continue;

      /* Start: first row visible, rest hidden */
      rows[0].classList.remove('prd-row--hidden');
      for (var j = 1; j < rows.length; j++) {
        rows[j].classList.add('prd-row--hidden');
      }

      /* Closure to capture current index per container */
      (function (rowList) {
        var current = 0;
        setInterval(function () {
          rowList[current].classList.add('prd-row--hidden');
          current = (current + 1) % rowList.length;
          rowList[current].classList.remove('prd-row--hidden');
        }, INTERVAL_MS);
      })(rows);
    }
  }

  /* Run on DOMContentLoaded */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPrdStatus);
  } else {
    initPrdStatus();
  }

  /* Re-init when new cards are injected (infinite scroll, AJAX filtering) */
  var observer = new MutationObserver(function (mutations) {
    var dominated = false;
    for (var m = 0; m < mutations.length; m++) {
      if (mutations[m].addedNodes.length) { dominated = true; break; }
    }
    if (dominated) initPrdStatus();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
